import React from 'react'
import { Link } from 'react-router-dom';

type Props = {
  letter:string;
}

const Header01 = ({letter}: Props) => {
  return (
    <div className="grid grid-cols-1 justify-items-stretch p-5 back-primary relative w-full">
        
        <Link className="left-0 lg:bottom-[-70%] bottom-[-50%] absolute cursor-pointer" to="/">
          <img
            src="/Others/logo.png"
            alt="Logo"
            className={`w-1/2 lg:w-2/4`}
          />
        </Link>

        <div className={`justify-self-end`}>
          <div className={`flex flex-row gap-3 items-center justify-end`}>
            <div className={`flex justify-center items-center relative z-0 `}>
              <img
                src="/Others/Cloud.png"
                alt='cloudImage'
                className={`lg:w-4/5 w-1/3 md:w-2/3`}
              />
              <div className="absolute inset-0 flex justify-center items-center z-10">
                <h4 className={`font-extrabold lg:text-8xl text-6xl word-primary`}>{letter}</h4>
              </div>
            </div>
            <img 
              src="/worldone/World_01.png" 
              alt="worldOne"
              className={`lg:w-1/6 w-1/3`}
            />
          </div>
        </div>

      </div>
  )
}

export default Header01